import React from 'react'
import styled from 'styled-components'
import { ProgressBar } from '../../screen-components/ProgressBar'
import { DSSpacer } from '@zoe/ds-web'
import { Menopause } from '../../../redux/quiz/types'
import { MenopauseAverageData } from '../../../libs/menoscale/utils'

type Props = {
  score: number
  menopauseStatus: Menopause
  averages: MenopauseAverageData | null
}

const TriangleDiv = styled.div`
  width: 0;
  height: 0;
`

const Triangle = ({ direction }: { direction: 'up' | 'down' }) => {
  const baseStyle = {
    borderTopColor: '#fff',
    borderRightColor: 'transparent',
    borderLeftColor: 'transparent',
    borderLeftWidth: '4px',
    borderRightWidth: '4px',
  }
  const downStyle = { ...baseStyle, borderTopWidth: '8px' }
  const upStyle = { ...baseStyle, borderBottomWidth: '8px' }

  return <TriangleDiv style={direction === 'up' ? upStyle : downStyle} />
}

const getAverages = (averages: MenopauseAverageData | null, menopauseStatus: Menopause) => {
  switch (menopauseStatus) {
    case 'perimenopausal':
      return [{ label: 'Average', average: averages?.perimenopausal }]
    case 'postmenopausal':
      return [{ label: 'Average', average: averages?.postmenopausal }]
    case 'do_not_know':
    case 'premenopausal':
    case 'prefer_not_to_say':
      return [
        { label: 'Postmenopausal', average: averages?.postmenopausal },
        { label: 'Perimenopausal', average: averages?.perimenopausal },
      ]
  }
}

const ProgressBarLabel = ({ label }: { label: string }) => (
  <span
    style={{
      fontSize: 'var(--font-size-fluid-label-100)',
      lineHeight: 'var(--line-height-fluid-label-100)',
      margin: 0,
      color: 'var(--colour-text-secondary-inverse)',
      width: 'max-content',
      transform: 'translate(-50%)',
      display: 'block',
    }}
  >
    {label}
  </span>
)

const ScoreBarRow = styled.div`
  width: 60%;
`

const ScoreBarRowFlex = styled.div`
  display: flex;
  justify-content: center;
  width: 60%;
`

export const MenoscaleScoreBar: React.FC<Props> = (props) => {
  const averages = getAverages(props.averages, props.menopauseStatus)
  return (
    <>
      <DSSpacer size={24} direction="vertical" />
      {averages && averages.length > 1 && (
        <ScoreBarRow>
          <div style={{ position: 'relative', transform: 'translate(-4px)', left: `${averages[1].average}%` }}>
            <ProgressBarLabel label={averages[1].label} />
            <Triangle direction="down" />
          </div>
        </ScoreBarRow>
      )}
      <ScoreBarRowFlex>
        <ProgressBar
          completionPercentage={props.score / 100}
          color="#FFD100"
          backgroundColor="rgba(255, 255, 255, 0.2)"
        />
      </ScoreBarRowFlex>
      {averages && averages.length > 0 && (
        <ScoreBarRow>
          <div style={{ position: 'relative', transform: 'translate(-4px)', left: `${averages[0].average}%` }}>
            <Triangle direction="up" />
            <ProgressBarLabel label={averages[0].label} />
          </div>
        </ScoreBarRow>
      )}
    </>
  )
}
